export default function setUserLocale({ state }) {
  const { user: { currentClient: { locale } }, locales } = state.get('client')
  if (locales.indexOf(locale) !== -1) {
    state.set('client.selectedLocale', locale)
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/actions/setUserLocale.js